export const ProgressRing = props => {
    return <zui-progress-ring emphasis="highlight" mode="activity" {...props}></zui-progress-ring>
}
